"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15.53 13.915c.263 0 .476.213.476.476v1.426h1.427l.095.01a.476.476 0 0 1-.095.942h-1.427v1.426a.476.476 0 0 1-.951 0V16.77h-1.427a.476.476 0 1 1 0-.952h1.427v-1.426c0-.263.213-.476.475-.476"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M15.57 11.167a5.167 5.167 0 1 1 0 10.333 5.167 5.167 0 0 1 .001-10.333m0 1.092a4.076 4.076 0 1 0 .001 8.151 4.076 4.076 0 0 0 0-8.151",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.024 12.023a.476.476 0 0 1-.095.94 7 7 0 0 0-3.889 1.223c-1.107.774-1.82 1.834-1.82 3.058 0 .399.185.677.537.899.376.236.92.387 1.55.473 1.266.173 2.61.055 3.146.055l.096.01a.477.477 0 0 1-.096.942c-.415 0-1.925.12-3.275-.064-.679-.093-1.382-.269-1.928-.612-.57-.358-.98-.913-.98-1.703 0-1.63.952-2.947 2.223-3.837a7.97 7.97 0 0 1 4.436-1.394z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M10.166 2.5a3.746 3.746 0 1 1 0 7.492 3.746 3.746 0 0 1 0-7.492m0 1.07a2.675 2.675 0 1 0 0 5.35 2.675 2.675 0 0 0 0-5.35",
    clipRule: "evenodd"
  })]
}), 'Recruit');
//# sourceMappingURL=index.js.map